import { inject, Injectable } from '@angular/core';
import { BASE_URL_TOKEN } from '@raptor-fe/core';

@Injectable({ providedIn: 'root' })
export class ServiceUtils {
    private readonly base_url = inject(BASE_URL_TOKEN);

    getBaseUrl(controller: string, tenantId?: string, branchId?: string, version = 'v1'): string {
        if (tenantId && branchId) return `${this.base_url}${version}/tenant/${tenantId}/branch/${branchId}/${controller}`;
        if (tenantId) return `${this.base_url}${version}/tenant/${tenantId}/${controller}`;
        return `${this.base_url}${version}/${controller}`;
    }
}
